import { queryClient } from "@/api/core";
import { QueryKeys } from "@/api/core/query-keys";
import { Status } from "@/schemas";

import { getActualStatus } from "./status";

const getStatusId = (initialStatusId?: string) => {
  const focusedElement = document.activeElement;
  if (focusedElement && focusedElement.id.startsWith("status-")) {
    return focusedElement.id.split("-")[1];
  }

  if (initialStatusId) return initialStatusId;

  const element = document.querySelector("[id^=status-]");
  if (element) {
    return element.id.split("-")[1];
  }
};

const getStatusFromCache = (initialStatusId?: string) => {
  const statusId = getStatusId(initialStatusId);
  if (!statusId) return;

  const statusDetails = queryClient.getQueryData(
    QueryKeys.statuses.detail(statusId),
  ) as Status;
  const allStatuses = queryClient.getQueryData(QueryKeys.statuses.global) as
    | Status[]
    | undefined;
  const status = statusDetails || allStatuses?.find((s) => s.id === statusId);

  if (status) return getActualStatus(status);
};

export { getStatusFromCache };
